<div class="container">
    <h2 *ngIf="!isLoading">{{report.name}}</h2>
    <div *ngIf="isPSCUser">
        <div class="security-container">
            <mat-card class="dealer-card">
                <div class="employee-search">
                    <span *ngIf="isPSCUser">{{plaintext.manageReportSecurity.ewa[user.language]}}</span>
                    <div *ngIf="isPSCUser" style="display: flex;">
                        <mat-form-field *ngIf="isPSCUser" appearance="fill" class="searchbox">
                            <input id="searchInput" matInput [ngModel]="employeeSearchInput"
                                (keyup)="searchEmployees($event.target.value)" [placeholder]="plaintext.table.sbn[user.language]">
                        </mat-form-field>
                        <button mat-button (click)="refreshEmpoloyees()">
                            <i-feather class="nav-icon" name="refresh-cw"></i-feather>
                        </button>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="isPSCUser && isDealersLoading"></mat-progress-bar>
                <app-data-table *ngIf="isPSCUser && !isDealersLoading" [displayedColumns]="employeeColumns"
                    [tableData]="employees" [initSortColumn]="0" [initSortDirection]="'asc'" [selectable]="true"
                    [selection]="addSelection" [height]="'400px'">
                </app-data-table>
                <div class="chip-list" *ngIf="isPSCUser">
                    <mat-chip-list>
                        <mat-chip *ngFor="let group of addSelection.selected" [removable]="true"
                            class="selected-chip">
                            {{group.name}}
                            <mat-icon matChipRemove (click)="deselectGroup(group)">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                </div>
            </mat-card>
    
            <button *ngIf="isPSCUser" class="remove-button" mat-raised-button
                [disabled]="addSelection.selected.length == 0 || createSecurityLoading"
                (click)="createReportSecurity()" color="primary">
                <div class="access-button-wrap">
                    {{plaintext.manageReportSecurity.grant[user.language]}}
                </div>
                <div class="access-button-spacing">
                    {{plaintext.manageReportSecurity.access[user.language]}}
                </div>
                <mat-spinner *ngIf="createSecurityLoading" class="button-spinner" [diameter]="30"></mat-spinner>
                <i-feather *ngIf="!createSecurityLoading" class="nav-icon" name="arrow-right"></i-feather>
            </button>
    
            <mat-card class="dealer-card">
                <span *ngIf="isPSCUser">{{plaintext.manageReportSecurity.ewoa[user.language]}}</span>
                <mat-progress-bar mode="indeterminate" *ngIf="isGroupsWithAccessLoading"></mat-progress-bar>
    
                <!-- PSC -->
                <div *ngIf="!isGroupsWithAccessLoading && isPSCUser" class="table-container">
                    <app-data-table [displayedColumns]="employeesWithAccessColumns" [tableData]="groupsWithAccess"
                        [initSortColumn]="0" [initSortDirection]="'asc'" [selectable]="true"
                        [selection]="removeSelection"  [height]="'500px'">
                    </app-data-table>
                    <button *ngIf="!isGroupsWithAccessLoading" mat-raised-button color="warn"
                        [disabled]="removeSelection.selected.length == 0" (click)="removeReportSecurity()"
                        class="grant-access-btn">
                        {{plaintext.manageReportSecurity.ra[user.language]}}
                    </button>
                </div>
            </mat-card>
        </div>
    </div>
</div>